/* screens/demo/DemoLegalDoc.jsx — правовые документы, показываемые ВНУТРИ модалки
 * заявки демо-стенда (без ухода на отдельную страницу /legal/*).
 * Оба документа — реальные, из общего LEGAL (тот же источник, что и /legal/offer и
 * /legal/privacy): пользовательское соглашение (offer) и политика конфиденциальности
 * (privacy, она же политика обработки и защиты персональных данных). */
import React from 'react';
import { LEGAL } from '../auth/legalContent.js';

const DOCS = { offer: LEGAL.offer, privacy: LEGAL.privacy };
// короткие заголовки для шапки модалки (полное название — внутри документа)
export const DEMO_LEGAL_TITLES = {
  offer: 'Пользовательское соглашение',
  privacy: 'Политика конфиденциальности',
};

// маркеры списков из исходных документов (как в LegalStub)
function isBullet(t) { return /^[•●▪\-–]\s/.test(t) || t.startsWith('●') || t.startsWith('•'); }
function stripBullet(t) { return t.replace(/^[•●▪\-–]\s*/, ''); }

function renderItems(items) {
  const out = [];
  let bucket = null;
  items.forEach((t, i) => {
    if (isBullet(t)) {
      if (!bucket) { bucket = []; out.push({ type: 'ul', items: bucket, key: 'ul-' + i }); }
      bucket.push(stripBullet(t));
    } else {
      bucket = null;
      out.push({ type: 'p', text: t, key: 'p-' + i });
    }
  });
  return out.map((node) => (node.type === 'ul'
    ? <ul key={node.key} className="demo-legal__list">{node.items.map((it, j) => <li key={j}>{it}</li>)}</ul>
    : <p key={node.key} className="demo-legal__p">{node.text}</p>));
}

export function DemoLegalDoc({ kind }) {
  const doc = DOCS[kind];
  if (!doc) return null;
  return (
    <div className="demo-legal">
      <div className="demo-legal__title">{doc.title}</div>
      {/* строку «Редакция от …» намеренно не показываем (в исходнике плейсхолдер даты) */}
      {(doc.intro || []).map((t, i) => <p key={'i' + i} className="demo-legal__p">{t}</p>)}
      {doc.sections.map((s) => (
        <section key={s.heading} className="demo-legal__sec">
          <div className="demo-legal__h">{s.heading}</div>
          {renderItems(s.items)}
        </section>
      ))}
    </div>
  );
}
